import { useMemo } from 'react';
import { useAccountId } from '../../../redux/slices/appInfo/hooks';
import { useChannelsNeedingReconnect } from '../../music24/navigation/hooks/useChannelsNeedingReconnect';
import { SMLSettingsTabId } from '../tabs/types';

/**
 * The red counts of the Settings rail (design navigation-v2 f 6b): Connections shows the social
 * accounts that need a new sign-in, the same count as the account card.
 */
export function useSettingsTabBadges(): Partial<Record<SMLSettingsTabId, number>> {
  const reconnect = useChannelsNeedingReconnect(useAccountId());
  return useMemo(() => ({ [SMLSettingsTabId.connections]: reconnect ?? 0 }), [reconnect]);
}
